// setBuildEnv.js
/**
 * Puts the build vars on globalThis.__BUILD_ENV__ so env.js can read them
 * from here instead of `process.env.*`.
 *
 * Why: the SW imports env.js. If env.js read these process.env values
 * directly, the SW would reinstall on every deploy. So the reads live here
 * — a file the SW doesn't import. Imported as the first internal import
 * in index.js so it runs before env.js needs it.
 */
globalThis.__BUILD_ENV__ = {
  TAG_NAME: process.env.TAG_NAME,
  BRANCH_NAME: process.env.BRANCH_NAME,
  SHORT_SHA: process.env.SHORT_SHA,
};
